import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

export function TabContent({ id, activeTab, content, loading = false }) {
	if (activeTab !== id) {
		return null;
	}

	return (
		<div
			id={`pane-${id}`}
			className={clsx("tab-pane is-active", { "is-loading": loading })}
			aria-labelledby={`tab-${id}`}
			tabIndex="0"
			role="tabpanel"
		>
			{content}
		</div>
	);
}

TabContent.propTypes = {
	id: PropTypes.string.isRequired,
	activeTab: PropTypes.string.isRequired,
	content: PropTypes.node.isRequired,
	loading: PropTypes.bool,
};
